//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { XTTrack, XTAlbum } from "@/models";
import MiniPlayerNoAudio from "@/components/music_player/MiniPlayerNoAudio.vue";
import AlbumItem from "@/components/xc_time/AlbumItem.vue";
import AlbumTags from "@/components/xc_time/AlbumTags.vue";
import TabAlbum from "@/components/tab/TabAlbum.vue";
import { mapGetters, mapMutations } from "vuex";
import filters from "@/filters";

let markdown = filters.markdown;

export default {
  data() {
    return {
      albumId: null,
      page: 1,
      perPage: 15,
      tracks: null,
      loading: false,

      // 在部分拥有简介的节目里启用
      list: ["节目", "简介"],
      selectedIndex: 0,
      isLockScrollBottom: false, // 当切换到第简介时，锁住声音列表的下拉加载
      isSpreadDescImg: false // 是否已经展开大纲图片
    };
  },

  created() {
    this.albumId = this.$route.params.albumId;

    this.getXTTracksByAlbum();
    this.clearAudioList();

    if (!this.currentAlbum) {
      // 如果状态中不存在当前Album的信息，主动去请求
      XTAlbum.getById(this.albumId).then(res => {
        this.setCurrentAlbum(res);
      });
    }
  },

  metaInfo() {
    return {
      title: this.title,
      // titleTemplate: null,
      meta: [{ name: "description", content: "中国传统文化音频平台" }]
    };
  },

  computed: {
    ...mapGetters(["currentAlbum"]),

    hasDesc() {
      if (this.currentAlbum) {
        return !!(
          this.currentAlbum.get("buyNotes") ||
          this.currentAlbum.get("outlineImageUrl") ||
          this.currentAlbum.get("richDesc") ||
          this.currentAlbum.get("speakerDesc")
        );
      }

      return false;
    },

    title() {
      return this.currentAlbum && this.currentAlbum.get("title");
    }
  },

  scrollBottom() {
    this.getXTTracksByAlbum();
  },

  methods: {
    ...mapMutations([
      "setCurrentAlbum",
      "setAudioList",
      "setCurrentTrack",
      "clearAudioList"
    ]),

    spreadImg() {
      this.isSpreadDescImg = true;
    },

    markdown(text) {
      return markdown(text);
    },

    clickTab(index) {
      this.isLockScrollBottom = index != 0;
      this.selectedIndex = index;
    },

    // goToXCTMusic (track, index) {
    //   this.$router.push({
    //     name: "xctMusic",
    //     params: {
    //       albumId: this.albumId,
    //       trackId: track.id
    //     }
    //   })
    // },

    getXTTracksByAlbum() {
      if (this.loading || this.isLockScrollBottom) {
        return;
      }

      this.loading = true;

      XTTrack.getXTTracksByAlbum(this.albumId, this.page, this.perPage).then(
        result => {
          if (result.length > 0) {
            this.setAudioList(result);

            if (!Array.isArray(this.tracks)) {
              this.tracks = result;
            } else {
              this.tracks = this.tracks.concat(result);
            }

            this.loading = false;
            this.page = this.page + 1;
          } else {
            console.log("已全部请求");
          }
        }
      );
    },

    // 如果work存在，前往work页面
    goToWork(work) {
      if (work) {
        this.$router.push({
          name: "work",
          params: {
            id: work.id
          }
        });
      }
    }
  },

  components: {
    MiniPlayerNoAudio,
    AlbumItem,
    TabAlbum,
    AlbumTags
  }
};



// WEBPACK FOOTER //
// ./src/pages/XCTAlbum.vue